import React from 'react'
import {useSelector} from 'react-redux'
import _ from 'lodash'
import {Fragment} from 'react'
import classNames from 'classnames'
import {useFormContext} from "react-hook-form";
import RenderedHtmlContent from "../../../../shared/virtual_congress/components/rendered_html_content";

const Rfid = () => {
  const {formState: { errors }, register} = useFormContext();

  const rfid = useSelector(state => state.rfid)
  const rfidText = useSelector(state => state.rfid.text).trim()

  const inputWidth = useSelector(state => state.input_width) || "8"
  const labelWidth = useSelector(state => state.label_width) || "3"

  const error = errors?.tag_owner?.rfid?.message

  return (
    <Fragment>
      {rfid.enabled &&
      <div className="form-group row" key={"coltag_owner.rfid"}>
        <label htmlFor="rfid.code" className={`col-md-${labelWidth} r-label col-form-label`}>
          <RenderedHtmlContent html={rfidText || "NFC Wristband"}/>
        </label>
        <div className={`col-md-${inputWidth}`}>
          <div className="form-check">
            <input
              {...register("rfid.code")}
              id="rfid.code"
              type="text"
              className={classNames("form-check-input", {"is-invalid": error})}/>
            {error && <div className="invalid-feedback"><RenderedHtmlContent html={error}/></div>}
          </div>
        </div>
      </div>
      }
    </Fragment>
  )
}
export default Rfid;